import { createAction } from "redux-act";
export const setAnnouncements = createAction("SET_ANNOUNCEMENTS", (announcements) => announcements);
export const setAvailableSurveys = createAction("SET_AVAILABLE_SURVEYS", (surveys) => surveys);
export const setSuppressSurvey = createAction("SET_SUPPRESS_SURVEY", (id, suppress) => ({ id, suppress }));
